/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserEssential = {
    properties: {
        id: {
            type: 'number',
            isRequired: true,
        },
        username: {
            type: 'string',
            isRequired: true,
        },
        variant: {
            type: 'string',
            isRequired: true,
        },
        givenName: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
        },
        familyName: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
        },
        photo: {
            type: 'any-of',
            contains: [{
                type: 'Image',
            }, {
                type: 'null',
            }],
        },
        blocked: {
            type: 'boolean',
            isRequired: true,
        },
        insiderScore: {
            type: 'number',
        },
        badges: {
            type: 'array',
            contains: {
                type: 'UserBadge',
            },
            isRequired: true,
        },
        playerId: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
        sports: {
            type: 'SportEnum',
            isRequired: true,
        },
        email: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
        },
        tel: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
        },
        pro: {
            type: 'boolean',
            isRequired: true,
        },
        adFree: {
            type: 'boolean',
            isRequired: true,
        },
        emailConfirmed: {
            type: 'boolean',
            isRequired: true,
        },
        telConfirmed: {
            type: 'boolean',
            isRequired: true,
        },
        anonymous: {
            type: 'boolean',
            isRequired: true,
        },
        deleted: {
            type: 'boolean',
            isRequired: true,
        },
    },
} as const;
